import React, { useState, useEffect } from 'react';
import "../styles/note.css"
import TeamNoteCard from '../components/TeamNoteCard';
import NotesInfo from '../components/InfoModals/NotesInfo';

export default function Notes({ addToast }) {
    const [selectedLeague, setSelectedLeague] = useState("");
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [showAddNote, setShowAddNote] = useState(false);
    const [showInfo, setShowInfo] = useState(false);

    const [loggedIn, setLoggedIn] = useState(false);

    //Rendezés, search bar..
    const [allTeams, setAllTeams] = useState([]);
    const [globalSearch, setGlobalSearch] = useState("");
    const [isGlobalSearch, setIsGlobalSearch] = useState(false);
    const [sortBy, setSortBy] = useState("newest");

    //NOTE POST ADATOK
    const [postNoteTitle, setPostNoteTitle] = useState("");
    const [postNoteText, setPostNoteText] = useState("");

    // Szükséges adatok statekben
    const [leagues, setLeagues] = useState([]);
    const [teamsByLeague, setTeamsByLeague] = useState([]);
    const [noteByTeamUser, setNoteByTeamUser] = useState([]);


    //TITLE, META TAG BEÁLLITÁS
    useEffect(() => {
        document.title = "Saját sportfogadási jegyzetek – Tippkövetés és elemzés | FociFanatik";

        const meta = document.querySelector("meta[name='description']");
        if (meta) {
            meta.setAttribute(
                "description",
                "Saját sportfogadási jegyzetek és tippkövetés egy helyen. Elemezd a múltbeli fogadásaidat statisztikák segítségével."
            );
        }
    }, []);



    //BEVAN-E JELENTKEZVE
    useEffect(() => {
        fetch("https://focifanatik.hu/api/session_check.php", {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                setLoggedIn(data.loggedIn);
            });
    }, []);


    // Kereső csapatok
    useEffect(() => {
        fetch("https://focifanatik.hu/api/get_all_teams.php", {
            credentials: "include"
        })
            .then(res => res.json())
            .then(setAllTeams)
            .catch(() => setAllTeams([]));
    }, []);






    const handleSaveNote = async () => {
        if (!loggedIn) {
            window.location.href = "/regisztracio";
            return;
        }

        if (!postNoteTitle || !postNoteText || !selectedTeam) return;

        const res = await fetch("https://focifanatik.hu/api/add_note.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                team_id: selectedTeam.id,
                title: postNoteTitle,
                note: postNoteText
            })
        });

        const data = await res.json();

        if (data.success) {
            setPostNoteTitle("");
            setPostNoteText("");
            setShowAddNote(false);

            // frissítés
            fetch(`https://focifanatik.hu/api/get_note.php?team_id=${selectedTeam.id}`)
                .then(res => res.json())
                .then(setNoteByTeamUser);
        }
    };

    const handleDeleteNote = (id) => {
        if (!loggedIn) {
            window.location.href = "/regisztracio";
            return;
        }

        fetch(`https://focifanatik.hu/api/delete_note.php?id=${id}`, {
            method: "DELETE",
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    addToast("Jegyzet sikeresen törölve!", "success");

                    setNoteByTeamUser(prev => prev.filter(s => s.id !== id));
                } else {
                    addToast(data.error || "Hiba történt!", "warning");
                }
            })
            .catch(() => addToast("Hálózati hiba!", "warning"));
    }



    // LIGÁK LEKÉRÉSE
    useEffect(() => {
        fetch("https://focifanatik.hu/api/admin_leagues.php", {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data)) {
                    setLeagues(data);
                } else {
                    console.error("Nem tömb jött vissza:", data);
                    setLeagues([]);
                }
            })
            .catch(err => {
                console.error("Fetch hiba:", err);
                setLeagues([]);
            });
    }, []);

    //CSAPATOK LEKÉRÉSE LIGA ALAPJÁN
    useEffect(() => {
        if (!selectedLeague) {
            setTeamsByLeague([]); // nincs liga → nincs csapat
            return;
        }

        fetch(`https://focifanatik.hu/api/admin_teams_by_league.php?league_id=${selectedLeague}`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                setTeamsByLeague(Array.isArray(data) ? data : []);
            })
            .catch(() => setTeamsByLeague([]));
    }, [selectedLeague]);

    //NOTE-OK LEKÉRÉSE CSAPAT ÉS USER ALAPJÁN
    useEffect(() => {
        if (!selectedTeam || !loggedIn) {
            setNoteByTeamUser([]);
            return;
        }

        fetch(`https://focifanatik.hu/api/get_note.php?team_id=${selectedTeam.id}`)
            .then((response) => response.json())
            .then((data) => {
                console.log("Kapott adatok:", data);
                setNoteByTeamUser(data);
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, [selectedTeam]);



    //Rendezés gomb
    const sortedNotes = [...noteByTeamUser].sort((a, b) => {
        if (sortBy === "newest") {
            return new Date(b.created_at) - new Date(a.created_at);
        }

        if (sortBy === "oldest") {
            return new Date(a.created_at) - new Date(b.created_at);
        }

        if (sortBy === "title") {
            return a.title.localeCompare(b.title, "hu");
        }

        return 0;
    });




    //Kereső
    useEffect(() => {
        if (globalSearch.length > 1) {
            setIsGlobalSearch(true);
        } else {
            setIsGlobalSearch(false);
        }
    }, [globalSearch]);


    const filteredTeams =
        globalSearch.length > 1
            ? allTeams.filter(team =>
                team.short_name.toLowerCase().includes(globalSearch.toLowerCase())
            )
            : teamsByLeague;

    const teamsToShow = filteredTeams;



    return (
        <div className="notes-page">

            <div className='note-header'>

                {/* Info gomb bal oldal */}
                <div className='note-header-left'>
                    <button
                        className="btn-info-notes"
                        onClick={() => setShowInfo(true)}
                    >
                        <i class="bi bi-info-lg"></i>
                    </button>
                </div>

                {/* Search bar középen */}
                <div className='note-header-center'>
                    <input
                        className="note-header-search"
                        type="search"
                        placeholder="Keresés jegyzetek között..."
                        value={globalSearch}
                        onChange={(e) => setGlobalSearch(e.target.value)}
                    />
                </div>

                {/* Rendezés jobb oldal */}
                <div className='note-header-right'>
                    <select className="note-header-sort" value={sortBy} onChange={((e) => setSortBy(e.target.value))}>
                        <option value="newest">Legújabb elöl</option>
                        <option value="oldest">Legrégebbi elöl</option>
                        <option value="title">Cím szerint</option>
                    </select>
                </div>

            </div>

            {/* ===== MOBIL LIGA + CSAPAT VÁLASZTÓ ===== */}
            <div className="mobile-selects">

                {/* LIGA SELECT */}
                <select
                    value={selectedLeague || ""}
                    onChange={(e) => {
                        const leagueId = Number(e.target.value);
                        setSelectedLeague(leagueId || "");
                        setSelectedTeam(null);
                        setShowAddNote(false);
                        setGlobalSearch("");
                        setIsGlobalSearch(false);
                    }}
                >
                    <option value="">Válassz ligát</option>
                    {leagues.map(league => (
                        <option key={league.id} value={league.id}>
                            {league.name}
                        </option>
                    ))}
                </select>

                {/* CSAPAT SELECT – CSAK HA VAN LIGA */}
                {selectedLeague && (
                    <select
                        value={selectedTeam?.id || ""}
                        onChange={(e) => {
                            const teamId = Number(e.target.value);
                            const team = teamsByLeague.find(t => t.id === teamId);
                            setSelectedTeam(team || null);
                            setShowAddNote(false);
                        }}
                    >
                        <option value="">Válassz csapatot</option>
                        {teamsByLeague.map(team => (
                            <option key={team.id} value={team.id}>
                                {team.short_name}
                            </option>
                        ))}
                    </select>
                )}

            </div>



            <div className="notes-layout container-fluid">
                <div className='section-header'>
                    <h5 className="content-title">Ligák</h5>
                </div>
                {/* =================== KÖZÉPSŐ LIGA MENÜ =================== */}
                <div className="league-row">
                    {leagues.map((league) => (
                        <button
                            key={league.id}
                            className={`league-pill ${selectedLeague === league.id ? "active" : ""
                                }`}
                            onClick={() => {
                                setSelectedLeague(league.id);
                                setSelectedTeam(null);
                                setShowAddNote(false);
                                setGlobalSearch("");
                                setIsGlobalSearch(false);
                            }}
                        >
                            {league.name}
                        </button>
                    ))}

                </div>

                {/* =================== KÖZÉPSŐ CSAPAT TARTALOM =================== */}
                <main className="notes-content">


                    {!selectedLeague && (
                        <p className="placeholder-text">
                            Válassz ki egy ligát a fenti kártyák közül!
                        </p>
                    )}


                    {/* InfoModal */}
                    {showInfo && <NotesInfo onClose={() => setShowInfo(false)} />}

                    {(selectedLeague || isGlobalSearch) && (
                        <>
                            <div className='section-header'>
                                <h5 className="content-title">Csapatok</h5>
                            </div>
                            <div className={`team-grid ${isGlobalSearch ? "show-mobile" : ""}`}>
                                {teamsToShow.map((team) => (
                                    <div
                                        key={team.id}
                                        className={`team-card ${selectedTeam?.id === team.id ? "selected" : ""}`}
                                        onClick={() => {
                                            setSelectedTeam(team);
                                            setShowAddNote(false);
                                        }}
                                    >
                                        {team.short_name}
                                    </div>
                                ))}
                            </div>
                        </>
                    )}

                    {isGlobalSearch && (
                        <p className="text-muted mb-2">
                            🔍 Globális keresés – liga független
                        </p>
                    )}


                    {/* HA VAN KIVÁLASZTOTT CSAPAT */}
                    {selectedTeam && (
                        <>

                            <h5 className="mt-4 mb-3 team-title-text">{selectedTeam.short_name} Jegyzetei</h5>

                            {!loggedIn ? (
                                // ===== NINCS BEJELENTKEZVE =====
                                <div className="empty-state text-center mt-3">
                                    <i className="bi bi-lock fs-1 text-muted"></i>

                                    <h6 className="mt-3 fw-semibold">
                                        A jegyzetek használata regisztrációhoz kötött
                                    </h6>

                                    <p className="text-muted">
                                        Jelentkezz be vagy regisztrálj, hogy elmentsd és
                                        visszanézd a saját elemzéseidet.
                                    </p>

                                    <button
                                        className="btn btn-primary rounded-pill px-4 btn-note-register"
                                        onClick={() => window.location.href = "/regisztracio"}
                                    >
                                        Regisztráció
                                    </button>
                                </div>
                            ) : (

                                sortedNotes.map((note) => (
                                    <div className="saved-notes-list" key={note.id}>
                                        <TeamNoteCard
                                            id={note.id}
                                            logo={note.logo_url}
                                            short_name={note.short_name}
                                            onDelete={handleDeleteNote}
                                            title={note.title}
                                            date={note.created_at}
                                            text={note.note}
                                        />
                                    </div>
                                ))
                            )}




                            {/* LENYITHATÓ HOZZÁADÁS */}
                            {loggedIn && (
                                <div
                                    className="add-note-header"
                                    onClick={() => setShowAddNote(!showAddNote)}
                                >
                                    <span className='add-note-title'> Új jegyzet hozzáadása</span>
                                    <button
                                        className="note-toggle-btn-note"
                                        onClick={() => setShowAddNote(!showAddNote)}
                                        title={showAddNote ? "Bezárás" : "Megnyitás"}
                                    >
                                        {showAddNote ? <i class="bi bi-arrow-up"></i> : <i class="bi bi-arrow-down"></i>}
                                    </button>
                                </div>
                            )}


                            {showAddNote && (
                                <div className="note-box">
                                    <h5 className="fw-bold mb-3 new-note-title">{selectedTeam.short_name} – Új jegyzet</h5>

                                    <span className='note-form-title'>Jegyzet címe</span>
                                    <input
                                        className="form-control mb-2"
                                        placeholder="Pl.: Játékstílusuk"
                                        value={postNoteTitle}
                                        onChange={e => setPostNoteTitle(e.target.value)}
                                    />

                                    <span className='note-form-title'>Jegyzet</span>
                                    <textarea
                                        className="form-control"
                                        rows={6}
                                        placeholder="Pl.: Labdatartó játékot játszanak, tamadásban kis passzokkal kombinálnak."
                                        value={postNoteText}
                                        onChange={e => setPostNoteText(e.target.value)}
                                    ></textarea>

                                    <button className="btn btn-success mt-3 px-4 btn-save" onClick={handleSaveNote}>
                                        Mentés
                                    </button>
                                </div>
                            )}


                        </>
                    )}

                </main>

            </div>
        </div>
    );

}